export interface RecentVisitItem {
  path: string;
  title: string;
  category: string;
  lastVisitedAt: string;
  visitCount: number;
}

const STORAGE_KEY = "harness-station-recent-visits";
const LEGACY_STORAGE_KEY = "data-station-recent-visits";
const MAX_ITEMS = 50;

const skippedPaths = new Set(["/", "/login", "/register", "/recent"]);

export function readRecentVisits(): RecentVisitItem[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY) ?? localStorage.getItem(LEGACY_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((item): item is RecentVisitItem => isRecentVisitItem(item))
      .sort((a, b) => new Date(b.lastVisitedAt).getTime() - new Date(a.lastVisitedAt).getTime());
  } catch {
    return [];
  }
}

export function clearRecentVisits(): void {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(LEGACY_STORAGE_KEY);
}

export function recordRecentVisit(pathname: string): void {
  if (pathname === "/" || pathname === "/login" || pathname === "/register") return;
  const path = normalizePath(pathname);
  if (!path || skippedPaths.has(path)) return;
  if (path.startsWith("/change-password")) return;
  if (path.startsWith("/projects/")) return;

  const current = readRecentVisits();
  const existing = current.find((item) => item.path === path);
  const nextItem: RecentVisitItem = {
    path,
    title: buildVisitTitle(path),
    category: buildVisitCategory(path),
    lastVisitedAt: new Date().toISOString(),
    visitCount: (existing?.visitCount ?? 0) + 1,
  };
  const next = [nextItem, ...current.filter((item) => item.path !== path)].slice(0, MAX_ITEMS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

function isRecentVisitItem(value: unknown): value is RecentVisitItem {
  if (!value || typeof value !== "object") return false;
  const item = value as Partial<RecentVisitItem>;
  return (
    typeof item.path === "string" &&
    typeof item.title === "string" &&
    typeof item.category === "string" &&
    typeof item.lastVisitedAt === "string" &&
    typeof item.visitCount === "number"
  );
}

function normalizePath(pathname: string): string {
  if (!pathname || pathname === "/") return "/dashboard";
  return pathname.replace(/\/+$/, "") || "/dashboard";
}

function buildVisitTitle(path: string): string {
  if (path === "/dashboard") return "个人总览";
  if (path === "/notifications") return "我的通知";
  if (path === "/permissions") return "我的权限";
  if (path === "/profile") return "个人资料";
  return path;
}

function buildVisitCategory(path: string): string {
  return "个人中心";
}
